export default __webpack_public_path__ + "static/media/2.359413fd.png";